import { FEATURE_FLAG_DOMAIN } from '@/features/flags/constants';
import { OpenFeature } from '@openfeature/react-sdk';

/**
 * Gates inlining structural styles (paragraph `margin:0`, `strong`→`b`,
 * `em`→`i`) onto copied HTML so external EHR paste targets render it
 * consistently. Read by the markdown helper (`reformatHtml`), which is not a
 * React component, so non-hook only. Default OFF ⇒ copied HTML is unchanged.
 *
 * Lives in this standalone `.ts` module (not the `index.tsx` barrel) so the
 * plain getter doesn't add a `react-refresh/only-export-components` warning to
 * the component barrel. Import it directly from
 * `@/features/flags/copy-external-paste-styles-flag`.
 */
export const isCopyExternalPasteStylesEnabled = () => {
  return OpenFeature.getClient(FEATURE_FLAG_DOMAIN).getBooleanValue(
    'release-scribe-copy-external-paste-styles',
    false
  );
};
